import { TopBar } from '@/layouts/TopBar';
import CandidatesList, {
  PER_PAGE,
} from '@candidates/components/CandidatesList';
import { useGetCandidates } from '@candidates/queries/useGetCandidates';

import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

const CandidatesPage = () => {
  const { t } = useTranslation();
  const { data } = useGetCandidates(
    { limit: PER_PAGE },
    { searchCriteria: [] },
  );

  return (
    <>
      <TopBar
        title={t('CANDIDATES')}
        count={data?.data.meta.itemCount}
      ></TopBar>
      <Box m={2}>
        <CandidatesList />
      </Box>
    </>
  );
};

export default CandidatesPage;
